import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PointsBlock, useConfig, useTranslations } from "@jti/ui";
import { useLoyaltyStatus } from "../../hooks/useLoyaltyStatus";
import styles from "./CartPoints.module.scss";
export const CartPoints = ({ totalPointsCount }) => {
    const { __ } = useTranslations();
    const { LOYALTY_KNOW_MORE_URL } = useConfig();
    const hasLoyaltyStatus = useLoyaltyStatus();
    if (totalPointsCount <= 0 || !hasLoyaltyStatus) {
        return null;
    }
    return (_jsxs("div", { className: styles.points, children: [_jsx("div", { className: styles.reward, children: `Ploom Club ${__("cart.ploom_club.reward")}` }), _jsx(PointsBlock, { hasLogo: false, knowMoreUrl: LOYALTY_KNOW_MORE_URL, urlText: __("cart.ploom_club.pointsBlock.link"), points: totalPointsCount, pointsLabel: __("cart.ploom_club.points"), text: __("cart.ploom_club.pointsBlock.message", [totalPointsCount]) })] }));
};
//# sourceMappingURL=CartPoints.js.map